<blaze-select
  #tagSelector
  class="input-tag"
  [class.multiple]="!!column.multipleValues"
  autocompletePosition="auto"
  [options]="availableTags"
  [multiselect]="!!column.multipleValues"
  [autocompleteAnimationDisabled]="true"
  [filtered]="true"
  [showNoneOption]="false"
  [closeDropdownOnSelect]="!column.multipleValues"
  [selectedTemplateRef]="chipTpl"
  [value]="formControl.value"
  (valueChange)="setSelectedTags($event)"
/>

<ng-template #chipTpl let-selectedItems let-onDeselect="onDeselect">
  @for (item of selectedItems; track item.label) {
    <div class="chip-option" [style.background]="item.backgroundColor">
      <span [style.color]="item.foregroundColor" class="whitespace-normal">{{ item.label }}</span>
      <button class="deselect-button" (click)="onDeselect(item)">
        <mat-icon svgIcon="icon_close_8" />
      </button>
    </div>
  }
</ng-template>
